import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';
import type { NodeProps } from '../types';

// Port of VE structured-content Tooltip (info variant, HelpOutline icon).
export function Tooltip({ props }: NodeProps<{ title?: string; content?: string }>) {
  if (!props?.content) return null;

  return (
    <DisclosureTooltip
      placement="top"
      trigger={
        <button
          aria-label={props.title ?? 'More information'}
          className="inline-flex cursor-pointer bg-transparent p-0 align-middle text-foreground"
          type="button"
        >
          <CircleHelp aria-hidden size="1.125rem" />
        </button>
      }
    >
      <span className="typography-text-small">
        {props.title ? <strong className="block">{props.title}</strong> : null}
        {props.content}
      </span>
    </DisclosureTooltip>
  );
}
